import apiClient from "./apiClient";

const ROOT = "/admin/finance/documents";

export const getFinanceDocuments = (params) => apiClient.get(ROOT, { params });
export const getFinanceDocument = (id) => apiClient.get(`${ROOT}/${id}`);
export const getFinanceDocumentPdf = (id) => apiClient.get(`${ROOT}/${id}/pdf`, {
  responseType: "blob",
  headers: { Accept: "application/pdf" },
});
export const downloadFinanceDocumentsZip = (payload) => apiClient.post(`${ROOT}/download-zip`, payload, {
  responseType: "blob",
  headers: { Accept: "application/zip" },
});
export const exportFinanceDocuments = (payload) => apiClient.post(`${ROOT}/export`, payload, {
  responseType: "blob",
  headers: { Accept: "application/octet-stream" },
});
export const emailFinanceDocuments = (payload) => apiClient.post(`${ROOT}/email-export`, payload);
